module.exports = __webpack_public_path__ + "static/img/ikonaIrfan-OFF.3b5bc841.png";